import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Extensions from './pages/Extensions';
import Partners from './pages/Partners';
import EndUsers from './pages/EndUsers';
import CreateEndUsers from './pages/CreateEndUsers';
import CreateExtension from './pages/CreateExtension';
import UpdateExtension from './pages/UpdateExtension';
import AddPartner from './pages/AddPartner';
import EditPartner from './pages/EditPartner';
import CreatePartner from './pages/CreatePartner';
import UpdatePassword from './pages/UpdatePassword';
import API from './pages/API';
import Layout from './components/Layout';
import TrainingVideos from './pages/TrainingVideos';
import ExtensionDetails from './pages/ExtensionDetails';
import UserDetails from './pages/UserDetails';
import EditUser from './pages/EditUser';
import ChangePlan from './pages/ChangePlan';

import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading state while checking authentication
  if (loading) {
    return <div>Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Main App Component
const AppContent = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="extensions" element={<Extensions />} />

        <Route path="partners" element={<Partners />} />
        <Route path="users" element={<EndUsers />} />
        <Route path="users/:id" element={<UserDetails />} />
        <Route path="users/:id/edit" element={<EditUser />} />
        <Route path="users/:id/plan" element={<ChangePlan />} />
        <Route path="create-extension" element={<CreateExtension />} />
        <Route path="update-extension/:id" element={<UpdateExtension />} />
        <Route path="create-partner" element={<AddPartner />} />
        <Route path="partners/:id/edit" element={<EditPartner />} />
        <Route path="create-user" element={<CreateEndUsers />} />
        <Route path="update-password" element={<UpdatePassword />} />
        <Route path="api" element={<API />} />

        <Route path="training-videos" element={<TrainingVideos />} />
        <Route path="extension/:id" element={<ExtensionDetails />} />
      </Route>
    </Routes>
  );
};

// App Component with Providers
const App = () => {
  return (
    <AuthProvider>
      <ScrollToTop />
      <AppContent />
    </AuthProvider>
  );
};

export default App; 